import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { getApiUrl, apiList } from 'src/app/core/Constants/apiList';
import { ApiResponse } from 'src/app/core/Models/interfaces/responseData';
import { UserService } from 'src/app/core/Services/user.service';

@Injectable({
  providedIn: 'root'
})
export class RuleConfigManageService {

  constructor(
    private http: HttpClient,
    private userService : UserService
    ) { }

  public getAllRules(filterPayload:any) {
    let endpoint = getApiUrl(apiList.rules.getRuleList,filterPayload);
    return this.http.get<any>(endpoint)
  }
  public getRuleListPayer(filterPayload:any,id:any) {
    let endpoint = getApiUrl(apiList.rules.getRuleListPayer,filterPayload,{ id:id });
    return this.http.get<any>(endpoint)
  }
  public getRuleListProvider(filterPayload:any,id:any) {
    let endpoint = getApiUrl(apiList.rules.getRuleListProvider,filterPayload,{ id:id });
    return this.http.get<any>(endpoint)
  }
  public getRuleConfigList(id:any,filterPayload?:any) {
    let endpoint = getApiUrl(apiList.rules.getRuleConfigListClient,filterPayload,{ id: id });
    if(this.userService.getPermissions('getclientRuleConfigList')){
      endpoint = endpoint;
    }else if(this.userService.getPermissions('getProviderClientRuleConfigList')){
      endpoint = getApiUrl(`api/v1/ruleConfiguration/provider/3/client/1`,filterPayload);
    }else if(this.userService.getPermissions('getPayerClientRuleConfigList')){
      endpoint = getApiUrl(`api/v1/ruleConfiguration/payer/2/client/1`,filterPayload);
    }
    return this.http.get<ApiResponse>(endpoint)
  }
  public getRuleConfigListPayer(id:any,filterPayload?:any) {
    // let endpoint = getApiUrl(apiList.rules.getRuleConfigListPayer,filterPayload,{ id: id });
    let endpoint = getApiUrl(`api/v1/ruleConfiguration/payer/2/client/1`,filterPayload);
    return this.http.get<any>(endpoint)
  }
  public getRuleConfigListProvider(id:any,filterPayload?:any) {
    // let endpoint = getApiUrl(apiList.rules.getRuleConfigListProvider,filterPayload,{ id: id });
    let endpoint = getApiUrl(`api/v1/ruleConfiguration/provider/3/client/1`,filterPayload);
    return this.http.get<any>(endpoint)
  }
  public getRuleConfigDetailsClient(id:any) {
    let endpoint = getApiUrl(apiList.rules.getRuleConfigDetailClient)+`/${id}`;
    return this.http.get<any>(endpoint)
  }
  public getRuleConfigDetailsPayer(id:any,versionId:any) {
    let endpoint = getApiUrl(apiList.rules.getRuleConfigDetailPayer)+`/${id}`+`/${versionId}`;
    return this.http.get<any>(endpoint)
  }
  public getRuleConfigDetailsProvider(id:any,versionId:any) {
    let endpoint = getApiUrl(apiList.rules.getRuleConfigDetailProvider)+`/${id}`+`/${versionId}`;
    return this.http.get<any>(endpoint)
  }
  public getDrugInHandExpiry(payload:any) {
    let endpoint = getApiUrl(apiList.rules.getDrugInHand,payload);
    return this.http.get<any>(endpoint)
  }
  public saveRuleConfigClient(payLoad:any) {
    let endpoint = getApiUrl(apiList.rules.saveConfigClient);
    return this.http.post<any>(endpoint,payLoad)
  }
  public saveRuleConfigPayer(payLoad:any) {
    let endpoint = getApiUrl(apiList.rules.saveConfigPayer);
    return this.http.post<any>(endpoint,payLoad)
  }
  public saveRuleConfigProvider(payLoad:any) {
    let endpoint = getApiUrl(apiList.rules.saveConfigProvider);
    return this.http.post<any>(endpoint,payLoad)
  }
  public editRuleConfig(id:any,payload:any) {
    let endpoint = getApiUrl(apiList.rules.editRule)+`/${id}`;
    if(this.userService.getPermissions('editRuleConfigVersion')){
      endpoint = endpoint;
    }else if(this.userService.getPermissions('editProviderRuleConfigVersion')){
      endpoint = getApiUrl(apiList.rules.editRule)+`/${id}/provider/3`;
    }else if(this.userService.getPermissions('editPayerRuleConfigVersion')){
      endpoint = getApiUrl(apiList.rules.editRule)+`/${id}/payer/2`;
    }
    
    return this.http.patch<ApiResponse>(endpoint,payload);
  }
  
}
